'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'comment';
var width = 512;
var height = 512;
var aliases = [128489,61669];
var unicode = 'f075';
var svgPathData = ['M16 240c0 53.5 21.1 101.1 54.2 142.1L28.1 485.4 153 442.5c32.9 13.6 67.2 21.5 103 21.5 133.5 0 240-101.2 240-224S389.5 16 256 16 16 117.2 16 240z', 'M70.2 382.1L28.1 485.4 153 442.5c32.9 13.6 67.2 21.5 103 21.5 133.5 0 240-101.2 240-224S389.5 16 256 16 16 117.2 16 240c0 53.5 21.1 101.1 54.2 142.1zM0 512L51.8 384.8C19.3 344.6 0 294.4 0 240 0 107.5 114.6 0 256 0S512 107.5 512 240 397.4 480 256 480c-36.8 0-71.9-7.3-103.5-20.4L0 512z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faComment = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;